import React, { useCallback, useEffect, useState } from "react";

import { useStores } from "../../../hooks/useStores";
import { observer } from "mobx-react";

import { useTranslation } from "react-i18next";
import { Alert, AlertIcon, Flex, useDisclosure } from "@chakra-ui/react";

import { EvaluationModal } from "../../../components/EvaluationModal";
import { EvaluationCard } from "../../../components/EvaluationCard";
import { Evaluation } from "../../../types";
import { PrimayButton } from "../../../components/Button";

export const TabEvaluations: React.FC = observer(() => {
  const { clientsStore, session } = useStores();
  const { t } = useTranslation();
  const [evaluation, setEvaluation] = useState<Evaluation | null>();
  const {
    isOpen: isModalOpen,
    onOpen: onModalOpen,
    onClose: onModalClose,
  } = useDisclosure();

  const handleSubmit = useCallback(
    async (data: any) => {
      try {
        if (clientsStore.customerData) {
          if (evaluation) {
            await clientsStore.updateEvaluation(data);
          } else {
            await clientsStore.addEvaluation(
              clientsStore.customerData.id,
              data
            );
          }
        }

        onModalClose();
        setEvaluation(null);
      } catch (err) {
        console.log(err);
      }
    },
    [clientsStore, evaluation, onModalClose]
  );

  const getEvaluations = useCallback(async () => {
    if (clientsStore.customerData) {
      await clientsStore.getEvaluation(clientsStore.customerData.id);
    }
  }, [clientsStore]);

  useEffect(() => {
    getEvaluations();
    if (!clientsStore.genericObjectives) {
      clientsStore.getGenericObjective(session.user?.id as string);
      clientsStore.getPersonalObjective(session.user?.id as string);
    }
  }, [clientsStore, clientsStore.customerData, getEvaluations, session.user]);

  const handleDelete = useCallback(
    async (data: any) => {
      try {
        if (data) {
          //DELETE
          await clientsStore.deleteEvaluation(data);
        }
      } catch (err) {
        console.log(err);
      }
    },
    [clientsStore]
  );

  return (
    <>
      <Flex flexFlow="row-reverse">
        <PrimayButton
          onClick={onModalOpen}
          disabled={
            !clientsStore.personalObjective ||
            clientsStore.genericObjectives.length === 0
          }
        >
          {t("screens.client.evaluation.btnNew")}
        </PrimayButton>
      </Flex>
      {(!clientsStore.personalObjective ||
        clientsStore.genericObjectives.length === 0) && (
        <Alert status="warning">
          <AlertIcon />
          Prima di inserire una valutazione, completare la sezione Obiettivi e
          Fattore X!
        </Alert>
      )}

      {clientsStore.evaluation?.map((item, index) => {
        return (
          <EvaluationCard
            onEdit={() => {
              setEvaluation(item);
              onModalOpen();
            }}
            dateOnTop={true}
            evaluation={item}
            onDelete={() => {
              handleDelete(item);
            }}
            prevEvaluationIndex={index + 1}
          />
        );
      })}

      <EvaluationModal
        isOpen={isModalOpen}
        evaluation={evaluation}
        onClose={() => {
          onModalClose();
          setEvaluation(null);
        }}
        onSubmit={handleSubmit}
      />
    </>
  );
});
